var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.494 7.96A16.03 16.03 0 0 0 16.04 19.506C18.18 20.051 20 18.21 20 16v-1c0-.552-.449-.995-.998-1.05a10 10 0 0 1-2.656-.639l-1.52 1.52A12.05 12.05 0 0 1 9.17 9.174l1.52-1.52a10 10 0 0 1-.64-2.656C9.995 4.448 9.552 4 9 4H8C5.79 4 3.949 5.819 4.494 7.96"
  })));
};
export default SvgPhone;